import { render, staticRenderFns } from "./WithdrawRecord.vue?vue&type=template&id=3fc7312b&scoped=true&"
import script from "./WithdrawRecord.vue?vue&type=script&lang=js&"
export * from "./WithdrawRecord.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawRecord.vue?vue&type=style&index=0&id=3fc7312b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc7312b",
  null
  
)

export default component.exports